import { combineReducers } from "redux";
import login from "./loginReducer";
import tasks from "./tasks";
import workTeams from "./workteams";
import community from "./community";
import projects from "./projects";
import reload from "./reload";
import files from "./files";
import links from "./links";
import agenda from "./agenda";
import assignments from "./assignments";

export default combineReducers({
  login,
  projects,
  tasks,
  workTeams,
  community,
  reload,
  files,
  links,
  agenda,
  assignments,
});
